export default __webpack_public_path__ + "static/media/pos-y.25856323.jpg";